const FooterComponent = {
    data() {
        return {
            activeCity: 0
        }
    },
    methods: {
        setActiveCity(index) {
            this.activeCity = index;
        }
    }
};

window.FooterComponent = FooterComponent;